import { useParams, useNavigate } from "react-router-dom";
import useAxios from "../../../hooks/useAxios";
import { useContext, useEffect, useState } from "react";
import { CircularProgress, Typography, Box, Button } from "@mui/material";
import QuestionCard from "../../../components/QuizComponents/Cards/QuestionCard/QuestionCard";
import './QuizReviewPage.css';
import Header from "../../../components/Header/Header";
import UpdateQuizGradesModal from "../../../components/QuizComponents/Modals/UpdateQuizGradesModal/UpdateQuizGradesModal";
import { AuthContext } from "../../../context/AuthContext";

const navLinks = [
    
];

function QuizReviewPage() {
    const { id: quizId } = useParams();
    const navigate = useNavigate();
    const axiosInstance = useAxios();
    const { status } = useContext(AuthContext);
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [updateGradesModalOpen, setUpdateGradesModalOpen] = useState(false);


    const fetchQuestions = async () => {
        try {
            const response = await axiosInstance.get(`/quizzes/${quizId}/questions`);
            if (response.data.success) {
                setQuestions(response.data.questions);
            } else {
                setError(response.data.message || "Failed to fetch questions.");
            }
        } catch (err) {
            setError(err.response?.data?.message || "An unexpected error occurred.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchQuestions();
    }, [quizId]);

    const handleUpdate = (id) => {
        navigate(`/update-question/${id}`);
    };

    const handleDelete = async (id) => {
        setLoading(true);
        setError(null);
    
        try {
            const response = await axiosInstance.delete(`/quizzes/${quizId}/questions/${id}`);
            if (response.data.success) {
                fetchQuestions(); // Re-fetch the updated list of questions
            } else {
                setError(response.data.message || "Failed to delete question.");
            }
        } catch (err) {
            setError(err.response?.data?.message || "An unexpected error occurred while deleting the question.");
        } finally {
            setLoading(false);
        }
    };

    const handleModalClose = (refreshNeeded) => {
        setUpdateGradesModalOpen(false);
        if (refreshNeeded) {
          fetchQuestions(); // Re-fetch questions if needed
        }
      };

      const handleSubmit = () => {
        if (status === 'trial') {
            navigate('/owner-quizzes');
        } else {
            navigate('/dashboard');
        }
      };
      
    
    

    if (loading) {
        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                minHeight="100vh"
            >
                <CircularProgress />
                <Typography variant="h6" sx={{ mt: 2 }}>
                    Fetching Questions...
                </Typography>
            </Box>
        );
    }

    if (error) {
        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                minHeight="100vh"
                textAlign="center"
            >
                <Typography variant="h6" color="error" gutterBottom>
                    {error}
                </Typography>
            </Box>
        );
    }

    return (
        <>
            <Header navLinks={navLinks} isScrollEffect={false} />
            <div className="quiz-review-container">
                <Typography className="quiz-review-title">
                Assessment's Questions :
                </Typography>
                {questions.map((question) => (
                    <QuestionCard
                        key={question.id}
                        question={question}
                        handleDelete={handleDelete}
                        handleUpdate={handleUpdate}
                    />
                ))}

            <div className="review-actions-container">
                <div className="top-row-buttons">
                    <Button
                        className="secondary-button"
                        onClick={() => {navigate(`/quiz/${quizId}/add-question`)}}
                    >
                        Add Question
                    </Button>
                    <Button
                        className="secondary-button"
                        onClick={() => setUpdateGradesModalOpen(true)}
                    >
                        Update Grades
                    </Button>
                </div>
                <div className="submit-button-container">
                    <Button
                        className="primary-button submit-button"
                         onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </div>
            </div>

            </div>
            <UpdateQuizGradesModal
                open={updateGradesModalOpen}
                onClose={handleModalClose}
                questions={questions}
                quizId={quizId}
            />
        </>
    );
}

export default QuizReviewPage;
